import {
  loadStudyPlan,
  selectWeekCalendarPlan
} from 'common/modules/ReactShared/data/redux/member/weekCalendar';
import {
  useTypedDispatch,
  useTypedSelector
} from 'common/modules/ReactShared/data/redux/_utils/hooks';
import { useEffect } from 'react';

// The tab bar remounts on every screen, so it asks once per session; Home and
// /study-plan reload the plan on their own mounts.
export function useHasStudyPlan(): boolean {
  const dispatch = useTypedDispatch();
  const { status, data } = useTypedSelector(selectWeekCalendarPlan);
  const isInitial = status === 'initial';

  useEffect(() => {
    if (isInitial) dispatch(loadStudyPlan());
  }, [dispatch, isInitial]);

  const hasPlan = data !== null;

  return hasPlan;
}
